var _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1479FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1479FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_25283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 20.5H19V19H13V20.5ZM13 17.5H19V16H13V17.5ZM11.5 23.5C11.0875 23.5 10.7344 23.3531 10.4406 23.0594C10.1469 22.7656 10 22.4125 10 22V10C10 9.5875 10.1469 9.23438 10.4406 8.94063C10.7344 8.64688 11.0875 8.5 11.5 8.5H17.5L22 13V22C22 22.4125 21.8531 22.7656 21.5594 23.0594C21.2656 23.3531 20.9125 23.5 20.5 23.5H11.5ZM16.75 13.75V10H11.5V22H20.5V13.75H16.75Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDocumentIcon);
export default __webpack_public_path__ + "static/media/dashboard-document-icon.55957be0c5b02879e4dfae1f329e8925.svg";
export { ForwardRef as ReactComponent };